import React from "react";
import { styled } from "@linaria/react";
import formatDate, { DAY_MS } from "@ui/i18n/formatDate";
import ActivityItem from "./ActivityItem";
import capitalize from "../../lib/capitalize";
import classNames from "classnames";
import { color, zIndex } from "@ui";
import { locale } from "../../i18n/locale";
import type { Project } from "../../api/useProjects";
import { fonts } from "@ui/Theme";
import type { Activity } from "../../api/useActivities";

export const EMBEDED_ACTIVITY = "embeded";

const Title = styled.div`
  background-color: ${color.titanium50};
  display: flex;
  padding: 10px 25px;
  color: ${color.carbon700};
  font: ${fonts.body2SemiBold};
  position: sticky;
  top: 50px;
  z-index: ${zIndex.overPositionedElements};
  width: 100%;

  &.${EMBEDED_ACTIVITY} {
    top: 0px;
    padding: 8px 16px;
  }
`;

const RelativeDate = styled.p`
  white-space: pre-wrap;
`;
const NumericDate = styled.p``;

const Group = styled.div``;

const formatCloseDay = (date: Date, locale: string) => {
  const shortDate = new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);
  const elapsed = Math.trunc((Number(shortDate) - Date.now()) / DAY_MS);

  if (Math.abs(elapsed) > 1) return; // display today and yesterday only
  return capitalize(
    new Intl.RelativeTimeFormat(locale, { numeric: "auto" }).format(elapsed, "days"),
  );
};

interface P {
  activities: Activity[];
  timeZone: string | null;
  embeded: boolean;
  projectsIndex: { [id: string]: Project };
}

const ActivityGroup = ({ activities, timeZone, embeded, projectsIndex }: P) => {
  const groupDate = activities[0]?.updatedAt;
  if (!groupDate) throw new Error("No date in activity");
  const closeDay = formatCloseDay(new Date(groupDate), locale);

  return (
    <>
      <Title className={classNames({ [EMBEDED_ACTIVITY]: embeded })}>
        {closeDay && <RelativeDate>{`${closeDay} - `}</RelativeDate>}
        <NumericDate>{formatDate(new Date(groupDate), "date", timeZone)}</NumericDate>
      </Title>
      <Group>
        {activities.map(activity => (
          <ActivityItem
            key={activity.id}
            data={activity}
            timeZone={timeZone}
            embeded={embeded}
            projectsIndex={projectsIndex}
          />
        ))}
      </Group>
    </>
  );
};

export default ActivityGroup;
